import MultiOptionsSwitch from "components/common/form/MultioptionSwitch";
import actions from "components/global/logic/actions";
import { assertArray } from "core/validation";
import PropTypes from "prop-types"; 
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { API_URL } from "services/index";

export function FilmRatingSwitch({ value, onChange, types, onLoadTypes }) {
    const options = types.map((t) => ({ ...t, value: t.id, label: t.name }));

    useEffect(() => {
        if (!assertArray(types)) {
            onLoadTypes();
        }
        if (!value) {
            const _value = options[0] ? options[0].value : null;
            onChange(_value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        
        
        
        
        <MultiOptionsSwitch
            value={value}
            options={options}
            onChange={onChange}
            
        />
    );
}
FilmRatingSwitch.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    types: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ),
    onLoadTypes: PropTypes.func.isRequired,
};
export default connect(
    ({ globalApp }) => ({
        types: globalApp.filmRatingTypes,
    }),
    (dispatch) => ({
        onLoadTypes: () => dispatch(actions.APP_GET_FILM_RATING_TYPE.send(API_URL.filmRatingT())),
    })
)(FilmRatingSwitch);
